import { ClientService } from '../../../shared/api/ClientService';

export const getAllocationsTotal = (agents?: ClientService.AgentAllocationItemDto[]) =>
  agents?.reduce((previous, item) => previous + (item?.allocationPercentage ?? 0), 0);
